import { useFormik } from 'formik'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import * as Yup from 'yup'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import BirthDayInput from '../../../components/v2/BirthDayInput'
import Dropdown from '../../../components/v2/Dropdown'
import GenderCard from '../../../components/v2/GenderCard'
import Input from '../../../components/v2/Input'
import MovingPrice from '../../../components/v2/MovingPrice'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WarningMessage from '../../../components/v2/WarningMessage'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import DialogModal from '../../../components/v2/modals/DialogModal'
import PetProgressbar from '../../../components/v2/progrees-bars/PetProgressBar'
import { RootState, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { AuthState } from '../../../store/authSlice'
import { PetState, setInsurerInfo, setInsurerObj, setInsurerTranslationInfo } from '../../../store/petSlice'
import { Helmet } from 'react-helmet-async'

const PetInsurer = () => {
  //
  const dispatch = useDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { lang, isProduction } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const [termsModalIsOpen, setTermsModalIsOpen] = useState<boolean>(false)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { checkout, screenHeader, filter } = useAppSelector((data: { pet: PetState }) => data.pet)
  //
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  // Sgs request
  const [sgsRequest, { isLoading: isSgsRequestLoading, data: sgsResult }] = api.useSgsRequestMutation()
  //
  //
  // ######################################################## set insurer obj from profile
  //
  //
  // SGS & set user info from SGS & if user not logged
  const requestSgsAndSetResponseData = useCallback(async () => {
    //
    const loggedUserNotHaveSgsVerification =
      auth &&
      auth.user &&
      auth.user.userType === 'User' &&
      auth.user.sgsVerification === false &&
      !checkout.insurer.sgsVerification &&
      !checkout.insurer.sgsVerificationSended &&
      checkout.insurer.cityzenship === 'GE' &&
      checkout.insurer.dateOfbirth &&
      (checkout.insurer.dateOfbirth as unknown as string)?.length === 14 &&
      checkout.insurer.idNumber &&
      checkout.insurer.idNumber.length === 11
    //
    const newUserSgsVerification =
      auth &&
      (!auth.user || (auth.user && auth.user.userType && auth.user.userType !== 'User')) &&
      !checkout.insurer.sgsVerification &&
      !checkout.insurer.sgsVerificationSended &&
      checkout.insurer.cityzenship === 'GE' &&
      checkout.insurer.dateOfbirth &&
      (checkout.insurer.dateOfbirth as unknown as string)?.length === 14 &&
      checkout.insurer.idNumber &&
      checkout.insurer.idNumber.length === 11
    //
    if (loggedUserNotHaveSgsVerification || newUserSgsVerification) {
      //
      // Convert the input date string to a JavaScript Date object
      const dateParts = (checkout.insurer.dateOfbirth && (checkout.insurer.dateOfbirth as unknown as string))
        ?.split('/')
        .map((part) => part.trim())
      const formattedDate = dateParts && new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`)

      // Format the date to "YYYY-MM-DD"
      const formattedDateString = formattedDate && formattedDate?.toISOString()?.split('T')[0]
      //
      if (formattedDateString && checkout.insurer.idNumber && isProduction) {
        //
        dispatch(
          setInsurerInfo({
            fieldName: 'sgsVerificationSended',
            fieldValue: true,
          }),
        )
        //
        try {
          //
          await sgsRequest({ birthday: formattedDateString, personalNumber: checkout.insurer.idNumber }).unwrap()
          //
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          }
        }
      }
      //
    }
    //
  }, [
    isProduction,
    auth,
    checkout.insurer.cityzenship,
    checkout.insurer.dateOfbirth,
    checkout.insurer.idNumber,
    checkout.insurer.sgsVerification,
    checkout.insurer.sgsVerificationSended,
    sgsRequest,
    dispatch,
  ])
  //
  // send SGS request
  useEffect(() => {
    requestSgsAndSetResponseData()
    //
    return () => {}
  }, [requestSgsAndSetResponseData])
  //
  // SGS
  //
  //
  //
  const formatDate = (dateString: any) => {
    const parts = dateString.split('-')!
    const formattedDate = `${parts[2]} / ${parts[1]} / ${parts[0]}`
    return formattedDate
  }
  //
  const formattedDateString = formatDate(auth.user?.birthday || '')
  //
  //
  const setSgsUserDataCallBack = useCallback(() => {
    //
    const checkEngFullName = () => {
      if (
        isProduction &&
        sgsResult &&
        sgsResult.sgsStatusText &&
        sgsResult.sgsStatusText.toLowerCase() === 'ok' &&
        (sgsResult.translations?.en?.firstName || sgsResult.translations?.en?.lastName) === null
      ) {
        sessionStorage.setItem('engFullName', 'false')
      }
    }
    //
    // set sgs response data
    if (isProduction && sgsResult && sgsResult.sgsStatusText && sgsResult.sgsStatusText.toLowerCase() === 'ok') {
      return [
        dispatch(
          setInsurerObj({
            cityzenship: checkout.insurer.cityzenship,
            dateOfbirth: checkout.insurer.dateOfbirth,
            idNumber: checkout.insurer.idNumber,
            gender: sgsResult.gender,
            sgsVerification: true,
            sgsVerificationSended: true,
            translations: {
              ge: {
                firstName: sgsResult.translations?.ge?.firstName,
                lastName: sgsResult.translations?.ge?.lastName,
              },
              en: {
                firstName: sgsResult.translations?.en?.firstName,
                lastName: sgsResult.translations?.en?.lastName,
              },
            },
          }),
        ),
        checkEngFullName(),
      ]
    }
    //
  }, [
    checkout.insurer.cityzenship,
    checkout.insurer.dateOfbirth,
    checkout.insurer.idNumber,
    sgsResult,
    isProduction,
    dispatch,
  ])
  //
  //
  useEffect(() => {
    setSgsUserDataCallBack()
    //
    return () => {}
  }, [setSgsUserDataCallBack])
  //
  //
  //
  //
  const setUserCallBack = useCallback(() => {
    //
    // set user info from logged user & if user is logged
    if (
      auth &&
      auth.user &&
      auth.user.userType &&
      auth.user.userType === 'User' &&
      !checkout.insurer.sgsVerificationSended
    ) {
      return [
        dispatch(
          setInsurerObj({
            cityzenship: auth.user.citizenship || undefined,
            dateOfbirth: (formattedDateString as unknown as Date) || undefined,
            idNumber: auth.user.personalNumber || undefined,
            gender: auth.user.gender || undefined,
            consentTerm: auth.user?.agreeToTerms?.consentTerm || undefined,
            privacyTerm: auth.user?.agreeToTerms?.privacyTerm || undefined,
            translations: {
              ge: {
                firstName: auth?.user?.firstNameGe || undefined,
                lastName: auth?.user?.lastNameGe || undefined,
              },
              en: {
                firstName: auth?.user?.firstName || undefined,
                lastName: auth?.user?.lastName || undefined,
              },
            },
          }),
        ),
      ]
    }
    //
    //
  }, [auth, formattedDateString, dispatch, checkout.insurer.sgsVerificationSended])
  //
  //
  useEffect(() => {
    setUserCallBack()
    return () => {}
  }, [setUserCallBack])
  //
  // ######################################################## set insurer obj from profile
  //
  //
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  //
  // georgian letter regex
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  const ValidationSchema = Yup.object({
    cityzenship: Yup.string().required(`${t('required')}`),
    idNumber: Yup.string()
      .min(11, `${t('personalNumberValidation')}`)
      .max(11, `${t('personalNumberValidation')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .required(`${t('required')}`),
    dateOfbirth: Yup.string().required(`${t('required')}`),
    firstName: Yup.string()
      .min(2, `${t('minNameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    lastName: Yup.string()
      .min(2, `${t('minSurnameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    firstNameGe: Yup.string()
      .min(2, `${t('minNameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(georgianLetterRegex, `${t('onlyGeorgianLetters')}`)
      .when('cityzenship', {
        is: 'GE',
        then: Yup.string().required(`${t('required')}`),
        otherwise: Yup.string(),
      }),
    lastNameGe: Yup.string()
      .min(2, `${t('minSurnameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(georgianLetterRegex, `${t('onlyGeorgianLetters')}`)
      .when('cityzenship', {
        is: 'GE',
        then: Yup.string().required(`${t('required')}`),
        otherwise: Yup.string(),
      }),
    gender: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .required(`${t('required')}`),
    consentTerm: Yup.boolean().oneOf([true]).required(),
  })
  //
  const initialValues = {
    cityzenship: checkout.insurer.cityzenship || '',
    idNumber: checkout.insurer.idNumber || '',
    dateOfbirth: checkout.insurer.dateOfbirth || '',
    firstName: checkout.insurer.translations?.en?.firstName || '',
    lastName: checkout.insurer.translations?.en?.lastName || '',
    firstNameGe: checkout.insurer.translations?.ge?.firstName || '',
    lastNameGe: checkout.insurer.translations?.ge?.lastName || '',
    gender: checkout.insurer.gender || '',
    consentTerm: checkout.insurer.consentTerm || null,
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: () => {},
  })
  //
  //
  // get diff age function
  const calculateAgeFromDate = (dateString: any) => {
    if (typeof dateString === 'string') {
      // Remove any whitespace from the string
      dateString = dateString.replace(/\s/g, '')

      // Extract day, month, and year from the string
      var parts = dateString.split('/')
      var birthDate = new Date(parts[2], parts[1] - 1, parts[0])

      // Calculate the difference in years
      var ageDiff = Date.now() - birthDate.getTime()
      var ageDate = new Date(ageDiff)

      return Math.abs(ageDate.getUTCFullYear() - 1970)
    }

    return null
  }
  //
  const diffage = calculateAgeFromDate(checkout.insurer?.dateOfbirth)
  //
  const closeTermsModal = () => {
    setTermsModalIsOpen(false)
  }
  //
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('pet-your-personal-info')
  //
  const pageTitle = pageInfo?.translations[lang]?.title
  const stepName = pageInfo?.translations[lang]?.stepName
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (filter?.petCategoryId === null) {
      navigate('/choose-pet')
    }
    //
    return () => {}
  }, [filter?.petCategoryId, navigate])
  //
  // when ssgs not response en first name and last name
  const engFullNameFromSgs = sessionStorage.getItem('engFullName') ? false : true
  //
  const MainLoading = isCountriesLoading || isSgsRequestLoading || isPageInfoLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <DialogModal
        title={t('consent')}
        isOpen={termsModalIsOpen}
        onClose={closeTermsModal}
        src={`${document.location.origin}/consent-dialog`}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'consentTerm',
              fieldValue: true,
            }),
          ),
          formik.setFieldValue('consentTerm', true),
          closeTermsModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'consentTerm',
              fieldValue: false,
            }),
          ),
          formik.setFieldValue('consentTerm', false),
          closeTermsModal(),
        ]}
      />

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <MovingPrice price={filter?.offerTotalPrice} currency="GEL" />

      <Container>
        <Content>
          <Title text={pageTitle} />

          <PetProgressbar stepName={stepName} />

          <WhiteBox>
            <BoxTitle>{pageTitle}</BoxTitle>

            <Inputs>
              {countries && (
                <Dropdown
                  title={`${t('cityzenship')}`}
                  isSearchable={true}
                  isDisabled={
                    (auth?.user?.citizenship && auth.user?.userType === 'User') ||
                    (checkout.insurer.sgsVerification === true && checkout.insurer.cityzenship)
                      ? true
                      : false
                  }
                  value={countries.find((x) => x.isoCode === checkout.insurer?.cityzenship)?.isoCode}
                  options={[
                    ...countries.map((c) => ({
                      value: c.isoCode,
                      label: c.translations?.[lang]?.name,
                    })),
                  ]}
                  onChange={(target) => [
                    dispatch(
                      setInsurerInfo({
                        fieldName: 'cityzenship',
                        fieldValue: target.value,
                      }),
                    ),
                    formik.setFieldValue('cityzenship', target.value),
                  ]}
                  error={formik.errors.cityzenship && checkout.insurer.cityzenship ? true : false}
                  onBlur={formik.handleBlur}
                />
              )}

              <Input
                id="id-number"
                name="idNumber"
                label={`${t('personalNumber')}`}
                type="text"
                placeholder=""
                value={checkout.insurer.idNumber || ''}
                onChange={(value) => [
                  dispatch(
                    setInsurerInfo({
                      fieldName: 'idNumber',
                      fieldValue: value,
                    }),
                  ),
                  formik.setFieldValue('idNumber', value),
                ]}
                width={'fullWidth'}
                error={formik.errors.idNumber && checkout.insurer.idNumber ? true : false}
                errorText={formik.errors.idNumber}
                onBlur={formik.handleBlur}
                disabled={
                  (auth?.user?.personalNumber && auth.user?.userType === 'User') ||
                  (checkout.insurer.sgsVerification === true && checkout.insurer.idNumber)
                    ? true
                    : false
                }
              />

              {checkout.insurer.dateOfbirth !== undefined && diffage && diffage < 18 ? (
                <WarningMessage variant="light-red" text={t('ageIsNotValid')} />
              ) : null}

              <BirthDayInput
                width={'fullWidth'}
                disabled={
                  (auth?.user?.birthday && auth.user?.userType === 'User') ||
                  (checkout.insurer.sgsVerification === true && checkout.insurer.dateOfbirth)
                    ? true
                    : false
                }
                id="date-of-birth"
                label={t('dateOfBirth')}
                placeholder={t('dayMonthYear')}
                // @ts-ignore
                value={checkout.insurer.dateOfbirth || ''}
                onChange={(value: string) => {
                  return [
                    dispatch(
                      setInsurerInfo({
                        fieldName: 'dateOfbirth',
                        fieldValue: value,
                      }),
                    ),
                    formik.setFieldValue('dateOfbirth', value),
                  ]
                }}
              />

              {checkout.insurer.cityzenship === 'GE' ? (
                <>
                  <Input
                    id="georgian-first-name"
                    name="firstNameGe"
                    label={`${t('nameInGeorgia')}`}
                    type="text"
                    placeholder=""
                    value={checkout.insurer.translations?.ge?.firstName || ''}
                    onChange={(value) => [
                      dispatch(
                        setInsurerTranslationInfo({
                          language: 'ge',
                          fieldName: 'firstName',
                          fieldValue: value,
                        }),
                      ),
                      formik.setFieldValue('firstNameGe', value),
                    ]}
                    width={'fullWidth'}
                    error={formik.errors.firstNameGe && checkout.insurer.translations?.ge?.firstName ? true : false}
                    errorText={formik.errors.firstNameGe}
                    onBlur={formik.handleBlur}
                    disabled={
                      (auth.user?.userType === 'User' && auth?.user?.firstNameGe) ||
                      (checkout.insurer.sgsVerification === true && checkout.insurer.translations?.ge?.firstName)
                        ? true
                        : false
                    }
                  />

                  <Input
                    id="georgian-last-name"
                    name="lastNameGe"
                    label={`${t('surnameInGeorgia')}`}
                    type="text"
                    placeholder=""
                    value={checkout.insurer.translations?.ge?.lastName || ''}
                    onChange={(value) => [
                      dispatch(
                        setInsurerTranslationInfo({
                          language: 'ge',
                          fieldName: 'lastName',
                          fieldValue: value,
                        }),
                      ),
                      formik.setFieldValue('lastNameGe', value),
                    ]}
                    width={'fullWidth'}
                    error={formik.errors.lastNameGe && checkout.insurer.translations?.ge?.lastName ? true : false}
                    errorText={formik.errors.lastNameGe}
                    onBlur={formik.handleBlur}
                    disabled={
                      (auth.user?.userType === 'User' && auth?.user?.lastNameGe) ||
                      (checkout.insurer.sgsVerification === true && checkout.insurer.translations?.ge?.lastName)
                        ? true
                        : false
                    }
                  />
                </>
              ) : null}

              <Input
                id="english-first-name"
                name="firstNameEn"
                label={`${t('nameInEnglish')}`}
                type="text"
                placeholder=""
                value={checkout.insurer.translations?.en?.firstName || ''}
                onChange={(value) => [
                  dispatch(
                    setInsurerTranslationInfo({
                      language: 'en',
                      fieldName: 'firstName',
                      fieldValue: value,
                    }),
                  ),
                  formik.setFieldValue('firstName', value),
                ]}
                width={'fullWidth'}
                error={formik.errors.firstName && checkout.insurer.translations?.en?.firstName ? true : false}
                errorText={formik.errors.firstName}
                onBlur={formik.handleBlur}
                disabled={
                  (auth.user?.userType === 'User' && auth?.user?.firstName) ||
                  (checkout.insurer.sgsVerification === true && engFullNameFromSgs === true)
                    ? true
                    : false
                }
              />

              <Input
                id="english-last-name"
                name="lastNameEn"
                label={`${t('surnameInEnglish')}`}
                type="text"
                placeholder=""
                value={checkout.insurer.translations?.en?.lastName || ''}
                onChange={(value) => [
                  dispatch(
                    setInsurerTranslationInfo({
                      language: 'en',
                      fieldName: 'lastName',
                      fieldValue: value,
                    }),
                  ),
                  formik.setFieldValue('lastName', value),
                ]}
                width={'fullWidth'}
                error={formik.errors.lastName && checkout.insurer.translations?.en?.lastName ? true : false}
                errorText={formik.errors.lastName}
                onBlur={formik.handleBlur}
                disabled={
                  (auth.user?.userType === 'User' && auth?.user?.lastName) ||
                  (checkout.insurer.sgsVerification === true && engFullNameFromSgs === true)
                    ? true
                    : false
                }
              />

              <GenderBlock>
                {['female', 'male'].map((item, index) => (
                  <GenderCard
                    key={index}
                    pet={false}
                    selected={checkout.insurer?.gender === item}
                    gender={item}
                    femaleText={`${t('female')}`}
                    maleText={`${t('male')}`}
                    onClick={() => [
                      dispatch(
                        setInsurerInfo({
                          fieldName: 'gender',
                          fieldValue: item,
                        }),
                      ),
                      formik.setFieldValue('gender', item),
                    ]}
                    error={formik.errors.gender && checkout.insurer.gender ? true : false}
                    errorText={formik.errors.gender}
                    onBlur={formik.handleBlur}
                  />
                ))}
              </GenderBlock>

              <Checkbox
                id="pet-insurer-frani-terms"
                label={`${t('franiTermsText')}`}
                // checked={checkout.insurer.consentTerm || false}
                defaultChecked={checkout.insurer.consentTerm || false}
                error={formik.errors.consentTerm && checkout.insurer.consentTerm === false ? true : false}
                onClick={() => setTermsModalIsOpen(true)}
              />
            </Inputs>
          </WhiteBox>

          <Buttons>
            <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/pet-offer')} />
            <NavigationButton
              text={`${t('next')}`}
              buttonType="next"
              disabled={formik.isValid && diffage && diffage >= 18 ? false : true}
              onClick={() => navigate('/pet-check-information')}
            />
          </Buttons>
        </Content>
      </Container>
      <BackgroundIcon />
    </Wrapper>
  )
}
//
//
const GenderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
`
const Inputs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  margin-top: 20px;
`
const BoxTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  margin-inline: auto;
  border-radius: 8px;
  padding: 34px 48px;
  position: sticky;
  z-index: 1;

  ${Responsive.mobile} {
    padding: 20px;
  }
`
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  padding-block: 60px;
  position: relative;
  z-index: 2;

  ${Responsive.mobile} {
    padding-block: 30px;
  }
`
const Wrapper = styled.div`
  /*  */

  .birtyday-input {
    font-weight: normal !important;
  }
`
//
export default PetInsurer
